
import templateUrl from './payroll-financials-program-summary.component.html'

export const PayrollFinancialsProgramSummaryComponent = {
    controller: PayrollFinancialsProgramSummaryController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        payrollFinancialProgramSummary: "<",
        aggregatesProgram: "<"
    }
};

function PayrollFinancialsProgramSummaryController($scope) {
    'ngInject';
    const vm = this;
    vm.$onInit = $onInit;
    vm.payrollFinancialProgramSummary;
    vm.columns;
    vm.sortColumns = [{ field: "OwnerName", dir: 1 }]; // Default
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass
    vm.pageNumber = 1;
    vm.pageSize = 25;
    vm.onSetSort = onSetSort;
    vm.sortFinancials = sortFinancials;
    vm.aggregatesProgram;

    function $onInit() {
        vm.columns = [

            {
                title: "Program",
                field: "ProgramName",
                sortable: true
            },
            {
                title: "Owner",
                field: "OwnerName",
                sortable: true
            },
            {
                title: "# of Show Days",
                field: "NumberOfShowDays",
                sortable: true
            },
            {
                title: "# of Hrs worked",
                field: "NoOfHoursWorked",
                sortable: true
            },
            {
                title: "# Hr/day",
                field: "HoursPerDay",
                sortable: true
            },
            {
                title: "NCR$",
                field: "NCRTTotal",
                sortable: true
            },
            {
                title: "NCR$/day",
                field: "NCRPerDay",
                sortable: true
            }
            ,
            {
                title: "NCR$/Hr",
                field: "NCRPerHour",
                sortable: true
            }


        ];
        $scope.$watch(function () {
            return vm.payrollFinancialProgramSummary;
        }.bind(vm), function () {
            if ((vm.pageNumber - 1) * vm.pageSize > vm.payrollFinancialProgramSummary.length) {
                vm.pageNumber = 1;
            }
        });

    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField.field;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField.field, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        vm.sortFinancials(vm.payrollFinancialProgramSummary);

    }

    function sortFinancials(financials) {

        return financials.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }
}
